import { render, staticRenderFns } from "./ShowClientPage.vue?vue&type=template&id=5495bd35&scoped=true"
import script from "./ShowClientPage.vue?vue&type=script&lang=js"
export * from "./ShowClientPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5495bd35",
  null
  
)

export default component.exports